import { render, staticRenderFns } from "./actualList.vue?vue&type=template&id=10ae503a&scoped=true"
import script from "./actualList.vue?vue&type=script&lang=js"
export * from "./actualList.vue?vue&type=script&lang=js"
import style0 from "./actualList.vue?vue&type=style&index=0&id=10ae503a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae503a",
  null
  
)

export default component.exports